const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class SubCategoryCarousel extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    this.carousel = new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 2.1,
          spacing: 5,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 3.1,
              spacing: 10,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 6,
              spacing: 10,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          container: this.els?.arrows?.element,
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )

    this.setAttribute('data-initialised', 'true')
  }
}

if (!customElements.get('sub-category-carousel')) {
  customElements.define('sub-category-carousel', SubCategoryCarousel)
}
